module.exports = __webpack_public_path__ + "fonts/mallorymp-book-webfont.3e7dadb94664dc08d84ba92c6ba02683.woff2";